import React, { useState, useEffect } from "react";

const ValuesTransitionAnimation = ({ values, onAnimationComplete }) => {
  const [animateToBottom, setAnimateToBottom] = useState(false);

  useEffect(() => {
    // Pills stay visible for 2 seconds, then start animation
    const animationTimer = setTimeout(() => {
      setAnimateToBottom(true);
    }, 2000); // Changed from 3000ms to 2000ms (2 seconds)

    // Call onComplete after pills stay (2s) + animation duration (1.4s) = 3.4s total
    const completeTimer = setTimeout(() => {
      onAnimationComplete?.();
    }, 3400); // Changed from 4400ms to 3400ms

    return () => {
      clearTimeout(animationTimer);
      clearTimeout(completeTimer);
    };
  }, [onAnimationComplete]);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Animated Pills */}
      <div className="flex flex-row justify-center items-center gap-4">
        {values.map((value, index) => (
          <div
            key={index}
            style={{
              width: animateToBottom ? 120 : 258,
              height: animateToBottom ? 32 : 68,
              borderRadius: 50,
              border: "1px solid #CCCCCC",
              background: "#54B0AF",
              padding: animateToBottom ? "6px 16px" : "17px 46px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transform: animateToBottom ? "translateY(400px) scale(0.8)" : "translateY(0) scale(1)",
              opacity: animateToBottom ? 0 : 1,
              transition: "all 1.4s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            <span
              style={{
                fontFamily: "Gotham",
                fontWeight: 700,
                fontSize: animateToBottom ? 12 : 20,
                lineHeight: "160%",
                letterSpacing: "0%",
                color: "#FFFFFF",
                textAlign: "center",
                transition: "font-size 1.4s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValuesTransitionAnimation;
